import Game from "../../../../src/Game";
import BaseSliderManager from "../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { EventBus, EnumEventBus } from "./EventBus";
import Checkbox from "../../../../src/entities/UI/Checkbox";
import { ANGLE_COLORS, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { SliderGenProps } from "../../../../src/types/Interface";


const SliderGen: SliderGenProps[] = [
  {
    head: "grow shape",
    colors: {
      bgColor: 0x21D4FE,
      barColor: 0x000000,
      buttonColor: 0x21D4FE
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.setGrowCircleValue, v - 100)
  },
  {
    head: "move the points",
    subHead: "(select which on the right)",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => EventBus.emit(EnumEventBus.movePoints, v - 100)
  }
]

const pointName = ["point A", "point B", "point C", "point D"];


export default class SliderManager extends BaseSliderManager {
  private EventBus = EventBus;
  pointCheckboxs: Checkbox[] = [];
  pointChecklist = Array(4).fill(false);
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
    this.checkVertical();
    this.RootEventBus.on(this.EnumRootEventBus.completedIntroAnim, () => this.addCheckBoxs())
  }
  checkVertical() {
    if (this.dim.WIDTH < this.dim.HEIGHT) {
      console.log("sadasdads");
      const slider = this.sliders[0];
      this.sliders.shift()
      slider.visible = false;
    }
  }
  handleCheckbox(label: string, v: boolean) {
    this.pointChecklist[pointName.indexOf(label)] = v;
    this.EventBus.emit(EnumEventBus.setPointChecklist, this.pointChecklist);
  }
  addCheckBoxs() {
    const coords = getPointCheckboxCoords(this.dim);
    this.pointCheckboxs = ANGLE_COLORS.map((e, eI) =>
      new Checkbox(coords[eI], pointName[eI], e, false, (label: string, v: boolean) => this.handleCheckbox(label, v)));
    this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxs.forEach(cbox => cbox.scale.set(.8));
  }
}


function getPointCheckboxCoords(dim: { WIDTH, HEIGHT }) {
  const getCoordHorizontal = (eI: number) => ({ x: 1185 + (eI > 1 ? 180 : 0), y: 775 + (eI % 2 == 1 ? 50 : 0) })
  const getCoordVertical = (eI: number) => ({
    x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
    y: dim.HEIGHT / 2 + 500 + (eI % 2 == 1 ? 40 : 0)
  })
  const coords = Array(4).fill(null).map((e, eI) => dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI));
  return coords
}